import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "#ED1C24",
      "fill-rule": "evenodd",
      "clip-path": "url(#a)",
      "clip-rule": "evenodd"
    }, [
      _createElementVNode("path", { d: "M18.757 7.427c.068-.021.157.022.246.14l4.03 3.98c.236.238.236.598 0 .774l-4.03 4.041c-.089.119-.178.148-.246.112s-.11-.14-.11-.292V7.686c0-.147.042-.237.11-.259M11.863.797h.285l.275.115 4.148 4.16c.178.237.117.417-.179.417h-1.719a.53.53 0 0 0-.531.536v3.088c0 .299-.24.536-.596.536h-3.02a.534.534 0 0 1-.536-.536V6.025a.53.53 0 0 0-.535-.536H7.618c-.296 0-.356-.18-.178-.417l4.15-4.16zM5.364 7.343c.075.036.122.14.122.291v8.672c0 .151-.047.241-.122.27-.07.029-.174 0-.296-.09l-4.09-4.16c-.236-.176-.236-.536 0-.773l4.09-4.099c.122-.119.225-.147.296-.111m5.161 6.821h3.021c.357 0 .596.238.596.536v3.268c0 .356.236.593.532.593h1.601c.296 0 .414.177.178.357l-4.03 4.098a.6.6 0 0 1-.417.18.6.6 0 0 1-.414-.18l-4.03-4.098c-.24-.18-.122-.357.174-.357h1.72c.299 0 .534-.237.534-.593V14.7c0-.298.24-.536.535-.536" })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h24v24H0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }